import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Asset.module.scss';
import newLineToBreakTag from '../../utils/strings/newLineToBreakTag';
import Video from '../Video'; // For 16x9, CENTER hero only.

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var sizes = [480, 600, 900, 1200, 1400];

var Asset = function Asset(_ref) {
  var _image$src, _video$src, _video$poster;

  var image = _ref.image,
      layout = _ref.layout,
      lazyload = _ref.lazyload,
      video = _ref.video;
  var isCentered = layout.indexOf('CENTER') > -1;
  var isSquare = layout.indexOf('1X1') > -1;
  var isPortrait = layout.indexOf('4X3') > -1;
  var hasImage = (image === null || image === void 0 ? void 0 : (_image$src = image.src) === null || _image$src === void 0 ? void 0 : _image$src.length) > 0;
  var hasVideo = (video === null || video === void 0 ? void 0 : (_video$src = video.src) === null || _video$src === void 0 ? void 0 : _video$src.length) > 0;
  var rootClass = cc([css.root, _defineProperty({}, css.split, !isCentered), _defineProperty({}, css.center, isCentered), _defineProperty({}, css.portrait, isPortrait)]);
  var sizesProps = isCentered ? {
    sizes: sizes
  } : {};
  var description = hasVideo ? video === null || video === void 0 ? void 0 : (_video$poster = video.poster) === null || _video$poster === void 0 ? void 0 : _video$poster.description : image === null || image === void 0 ? void 0 : image.description;

  var descriptionHtml = description && /*#__PURE__*/_jsx("figcaption", {
    className: css.description,
    dangerouslySetInnerHTML: {
      __html: newLineToBreakTag(description)
    }
  });

  var imageHtml = /*#__PURE__*/_jsxs("div", {
    className: rootClass,
    children: [/*#__PURE__*/_jsx("figure", {
      className: css.wrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: css.image,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread(_objectSpread({}, image), sizesProps), {}, {
          lazyload: lazyload,
          wrap: false
        }))
      })
    }), descriptionHtml]
  });

  if (hasVideo) {
    var poster = video.poster.src;
    var track = {
      src: video.track
    };
    return /*#__PURE__*/_jsx("div", {
      className: rootClass,
      children: /*#__PURE__*/_jsxs("figure", {
        className: cc([css.wrapper, _defineProperty({}, css.square, isSquare)]),
        children: [/*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({
          className: css.video
        }, video), {}, {
          poster: poster,
          track: track
        })), descriptionHtml]
      })
    });
  }

  if (hasImage && isCentered) {
    return imageHtml;
  }

  if (hasImage) {
    return /*#__PURE__*/_jsxs("figure", {
      className: rootClass,
      children: [/*#__PURE__*/_jsx("div", {
        className: cc([css.wrapper, css.imageLink, _defineProperty({}, css.square, isSquare)]),
        children: /*#__PURE__*/_jsx("div", {
          className: css.image,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
            lazyload: lazyload,
            wrap: false
          }))
        })
      }), descriptionHtml]
    });
  }

  return false;
};

Asset.defaultProps = {
  image: false,
  layout: '',
  lazyload: true,
  video: false
};
Asset.propTypes = {
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  layout: PropTypes.string,
  lazyload: PropTypes.bool,
  video: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()])
};
export default Asset;